import axios from '../utils/index';
import { Pat, HttpResponse } from '@/typings/request';
const couponApi = {
    async getOnlineCouponList(params: Pat) {
        return axios.get(`/coupon/list`, { params });
    },
    async getCouponCustomers(params: Pat) {
        return axios.get(`/coupon/customer/list`, { params });
    },
    async createOnlineCoupon(data: Pat) {
        return axios.post(`/coupon/create`, data);
    },
    async getCouponDetail(path: 'coupon' | 'voucher', couponId: string) {
        return axios.get(`/${path}/details/${couponId}`);
    },
    async pauseCoupon(path: 'coupon' | 'voucher', couponId: string) {
        return axios.get(`/${path}/pause/${couponId}`);
    },
    async exportCoupon(couponId: string) {
        return axios.get(`/coupon/export/usage/${couponId}`);
    },
    async getVoucherCouponList(params: Pat) {
        return axios.get(`/voucher/list`, { params });
    },
    async createVoucherCoupon(data: Pat) {
        return axios.post(`/voucher/create`, data);
    },
};

export default couponApi;
